<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      // this.$emit('setpage', 8);
      this.loading = false;
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Sign paperwork.png')" class="_w-m-350 mb-4" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Sign paperwork</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Now all that's left is signing the necessary documents. We will send you the signing session via email once we have reviewed your property information and photos. Please keep an eye out for our email.</p>
        <p class="text-info" data-aos="fade-zoom-in">Once everything is complete and we have entered the property into the MLS your listing will be moved to the "Listing is live" stage.</p>
      </div>

      <div class="row py-5">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 10 + (item.mls.form_fields ? item.mls.form_fields.length : 0))" :disabled="loading"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">

        </div>
      </div>
    </form>
  </div>

</template>
